import { Bruger } from './Bruger'; 
export class LogbogIndlaeg {
        public id: string;
        public brugerId: string;
        public bruger: Bruger;
        public logbogDialogId: string;
        public tekst: string;
        public createdDate: Date;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/LogbogIndlaeg.ts